module.exports = __webpack_public_path__ + "static/img/FuQuan_Bnner_summer.bd207751.jpg";